import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Grid,
  TextField,
  makeStyles,
  Container,
  Button,
  CardContent,
  Divider,
  InputLabel,
  CardHeader,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik, validateYupSchema } from 'formik';
import * as Yup from 'yup';
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import {
  DatePicker,
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import xlsx from 'json-as-xlsx';
import ReactToPrint from 'react-to-print';
import CreatePDF from './CreatePDF';
import { useAlert } from 'react-alert';
import TablePagination from '@material-ui/core/TablePagination';


const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: 'red'
  },
  colorRecord: {
    backgroundColor: 'green'
  }
}));

const screenCode = 'CASHCUSTOMERREPORT';

export default function CashCustomerReport(props) {
  const today = new Date();
  const [balancePaymentYearMonth, setBalancePaymentYearMonth] = useState();
  const [title, setTitle] = useState('Cash Customer Report');
  const classes = useStyles();
  const [cashCustomerDetail, setcashCustomerDetail] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    year: '',
    month: ''
  });
  const [FactoryList, setFactoryList] = useState([]);
  const [GroupList, setGroupList] = useState([]);
  const [routes, setRoutes] = useState();
  const [selectedDate, setSelectedDate] = useState();
  const [selectedDatePDF, setSelectedDatePDF] = useState();
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredCashCustomerData, setFilteredCashCustomerData] = useState([]);
  const [cashCustomerData, setCashCustomerData] = useState([]);
  const [month, setMonth] = useState(['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'])
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const navigate = useNavigate();

  const [csvHeaders, SetCsvHeaders] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    factoryName: '0',
    groupName: '0',
    year: '',
    monthName: '',
    routeName: ''
  });
  const componentRef = useRef();
  const [totalAmount, setTotalAmount] = useState(0);
  const alert = useAlert();
  const [alertCount, setAlertCount] = useState({
    count: 0
  });
  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(0);

  useEffect(() => {
    trackPromise(getPermission());
    trackPromise(getGroupsForDropdown());
    setAlertCount({
      count: 1
    });
  }, []);

  useEffect(() => {
    getFactoriesForDropdown();
    setAlertCount({
      count: alertCount.count + 1
    });
    setRoutes([]);
  }, [cashCustomerDetail.groupID]);

  useEffect(() => {
    trackPromise(getRoutesByFactoryID());
  }, [cashCustomerDetail.factoryID]);

  useEffect(() => {
    if (cashCustomerDetail.factoryID > 0 && cashCustomerDetail.groupID > 0) {
      trackPromise(GetBalancePaymentYearMonthForDropDown());
    }
  }, [cashCustomerDetail.factoryID, cashCustomerDetail.groupID]);

  useEffect(() => {
    if (searchQuery) {
        const filtered = cashCustomerData.filter(row => {
            const searchLower = searchQuery.toLowerCase().trim();
            const routeName = row.routeName?.toLowerCase().includes(searchLower);
            const registrationNumber = row.registrationNumber?.toLowerCase().includes(searchLower);
            const name = row.name?.toLowerCase().includes(searchLower);
            const amount = !isNaN(searchQuery) && row.amount === Number(searchQuery);

            return routeName || registrationNumber || name || amount;
        });
        setFilteredCashCustomerData(filtered);
    } else {
      setFilteredCashCustomerData(cashCustomerData);
    }
  }, [searchQuery, cashCustomerData]);


  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(
      p => p.permissionCode == 'VIEWCASHCUSTOMERREPORT'
    );

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(
      p => p.permissionCode == 'GROUPDROPDOWN'
    );
    var isFactoryFilterEnabled = permissions.find(
      p => p.permissionCode == 'FACTORYDROPDOWN'
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
    });

    setcashCustomerDetail({
      ...cashCustomerDetail,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    });
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value;
    if([e.target.name] == 'groupID'){
      setcashCustomerDetail({
        ...cashCustomerDetail,
        [e.target.name]: value,
        factoryID: 0,
        routeID: 0
      });
    } else if([e.target.name] == 'factoryID'){
      setcashCustomerDetail({
        ...cashCustomerDetail,
        [e.target.name]: value,
        routeID: 0
      });
    } else {
      setcashCustomerDetail({
        ...cashCustomerDetail,
        [e.target.name]: value
      });
    }
    setCashCustomerData([]);
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(
      cashCustomerDetail.groupID
    );
    setFactoryList(factories);
  }

  async function getRoutesByFactoryID() {
    const routeList = await services.getRoutesForDropDown(
      cashCustomerDetail.factoryID
    );
    setRoutes(routeList);
  }

  async function GetBalancePaymentYearMonthForDropDown() {
    var response = await services.GetBalancePaymentYearMonth(cashCustomerDetail.groupID, cashCustomerDetail.factoryID);

    const applicableYear = parseInt(response.applicableYear);
    const applicableMonth = parseInt(response.applicableMonth) - 1;

    const selectedDate = new Date(applicableYear, applicableMonth);

    setSelectedDate(selectedDate);
    setSelectedDatePDF(response);
  };

  async function GetDetails() {
    let total = 0;

    const applicableYear = selectedDate.getFullYear().toString();
    const applicableMonth = (selectedDate.getMonth() + 1).toString();

    let model = {
      groupID: parseInt(cashCustomerDetail.groupID),
      factoryID: parseInt(cashCustomerDetail.factoryID),
      routeID: parseInt(cashCustomerDetail.routeID),
      applicableMonth: applicableMonth,
      applicableYear: applicableYear
    };
    getSelectedDropdownValuesForReport(model);

    const customerData = await services.GetCashCustomerDetails(model);
    if (customerData.statusCode == 'Success' && customerData.data != null) {
      setCashCustomerData(customerData.data);
      customerData.data.forEach(x => {
        total = total + parseFloat(x.amount);
      });
      if (customerData.data.length == 0) {
        alert.error("NO RECORDS TO DISPLAY");
      } else {
        alert.success('Success');
      }
      setTotalAmount(total);
      createDataForExcel(customerData.data);
    } else {
      alert.error('NO RECORDS TO DISPLAY');
    }
  }

  async function createDataForExcel(array) {
    var res = [];

    if (array != null) {
      array.map(x => {
        var vr = {
          'Route Name': x.routeName,
          'Registration Number': x.registrationNumber,
          'Customer Name': x.name,
          'Amount(RS)': x.amount
        };
        res.push(vr);
      });
      res.push({});

      var vr = {
        'Route Name': 'Total',
        'Amount(RS)': totalAmount
      }
      res.push(vr);
      res.push({});

      var vr = {
        'Route Name': 'Group :' + selectedSearchValues.groupName,
        'Registration Number': 'Factory  :' + selectedSearchValues.factoryName,
      }
      res.push(vr);

      var vr = {
        'Route Name': selectedSearchValues.routeName == undefined ? 'Route :' + 'All Routes' : 'Route :' + selectedSearchValues.routeName,
      }
      res.push(vr);

      var vr = {
        'Route Name': 'Month and Year :' + month[(selectedDate.getMonth() + 1).toString() - 1] + ' - ' + selectedSearchValues.year,
      }
      res.push(vr);
    }

    return res;
  }

  async function createFile() {
    var file = await createDataForExcel(cashCustomerData);
    var settings = {
      sheetName: 'Cash Customer Details Report',
      fileName:
        'Cash Customer Details Report ' +
        selectedSearchValues.groupName +
        ' - ' +
        selectedSearchValues.factoryName +
        ' BOUGHT LEAF CASH PAYMENT FOR THE MONTH OF ' +
        month[(selectedDate.getMonth() + 1).toString() - 1] +
        ' - ' +
        selectedSearchValues.year,
      writeOptions: {}
    };

    let keys = Object.keys(file[0]);
    let tempcsvHeaders = csvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem });
    });

    let dataA = [
      {
        sheet: 'Cash Customer Details Report',
        columns: tempcsvHeaders,
        content: file
      }
    ];

    xlsx(dataA, settings);
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function handleDateChange(date) {
    let monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ];
    var month = date.getUTCMonth() + 1; //months from 1-12
    var year = date.getUTCFullYear();
    var currentmonth = moment().format('MM');
    let monthName = monthNames[month - 1];

    setSelectedSearchValues({
      ...selectedSearchValues,
      monthName: monthName
    });
    setcashCustomerDetail({
      ...cashCustomerDetail,
      month: month.toString(),
      year: year.toString()
    });

    if (selectedDate != null) {
      var prevMonth = selectedDate.getUTCMonth() + 1;
      var prevyear = selectedDate.getUTCFullYear();

      if ((prevyear == year && prevMonth != month) || prevyear != year) {
        setSelectedDate(date);
      }
    } else {
      setSelectedDate(date);
    }
    setCashCustomerData([]);
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      factoryName: FactoryList[searchForm.factoryID],
      groupName: GroupList[searchForm.groupID],
      routeName: routes[searchForm.routeID],
      monthName: searchForm.applicableMonth,
      year: searchForm.applicableYear
    });
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    );
  }
  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const getPageMargins = () => {
    return `@media print {
            @page {
            size: A4 Landscape !important;
            background-color: white !important;
        }
        body {
            transform-origin: top left;
            background-color: white !important;
        }
    }`;
  };

  return (
    <Fragment>
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: cashCustomerDetail.groupID,
              factoryID: cashCustomerDetail.factoryID
            }}
            validationSchema={Yup.object().shape({
              groupID: Yup.number()
                .required('Group is required')
                .min('1', 'Group is required'),
              factoryID: Yup.number()
                .required('Factory is required')
                .min('1', 'Factory is required')
            })}
            enableReinitialize
          >
            {({ errors, handleBlur, handleSubmit, touched }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={e => handleChange(e)}
                              value={cashCustomerDetail.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                              size="small"
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(
                                touched.factoryID && errors.factoryID
                              )}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={e => handleChange(e)}
                              value={cashCustomerDetail.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                              size="small"
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="routeID">
                              Route
                            </InputLabel>
                            <TextField
                              select
                              fullWidth
                              name="routeID"
                              onChange={e => handleChange(e)}
                              value={cashCustomerDetail.routeID}
                              variant="outlined"
                              id="routeID"
                              size="small"
                            >
                              <MenuItem value="0">--Select Route--</MenuItem>
                              {generateDropDownMenu(routes)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <DatePicker
                                autoOk
                                variant="inline"
                                openTo="month"
                                views={["year", "month"]}
                                label="Year and Month *"
                                helperText="Select applicable month"
                                value={selectedDate}
                                disableFuture={true}
                                onChange={date => handleDateChange(date)}
                                size="small"
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                        </Grid>
                        <Grid container justify="flex-end">
                          <Box pt={2}>
                            <Button
                              color="primary"
                              variant="contained"
                              type='submit'
                              onClick={() => trackPromise(GetDetails())}
                            >
                              Search
                            </Button>
                          </Box>
                        </Grid>

                        <br />
                        <br />
                        
                        <Box>
                          {cashCustomerData.length > 0 ? (
                            <TableContainer>
                              <Grid
                                style={{ marginBottom: '10px' }}
                                container
                                justify="flex-end"
                              >
                                <Box style={{ position: 'relative' }}>
                                  <TextField
                                    fullWidth
                                    label="Search"
                                    variant="outlined"
                                    size="small"
                                    style={{
                                      position: 'absolute',
                                      top: '10px',
                                      right: 0,
                                      width: '250px',
                                      marginRight: '3px',
                                    }}
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                  />
                                </Box>
                              </Grid>

                              <br />
                              <br />
                              <br />

                              <Table aria-label="caption table" size="small">
                                <TableHead>
                                  <TableRow>
                                    <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Route Name</TableCell>
                                    <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Registration Number</TableCell>
                                    <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Customer Name</TableCell>
                                    <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Amount(Rs)</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {(searchQuery ? filteredCashCustomerData : cashCustomerData).slice(page * limit, page * limit + limit).map((data, index) => (
                                    <TableRow key={index}>
                                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                        {data.routeName}
                                      </TableCell>
                                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                        {data.registrationNumber}
                                      </TableCell>
                                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                        {data.name}
                                      </TableCell>
                                      <TableCell align={'right'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                        {data.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                      </TableCell>
                                    </TableRow>  
                                  ))}
                                </TableBody>
                                <TableRow style={{ border: "1px solid #ccc" }}>
                                  <TableCell align={'left'} style={{ borderBottom: "none" }}><b>Total</b></TableCell>
                                  <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}></TableCell>
                                  <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}></TableCell>
                                  <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none", borderLeft: "1px solid #ccc" }}>
                                    <b>
                                      {cashCustomerData.reduce((sum, row) => sum + row.amount, 0).toLocaleString('en-US', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                      })}
                                    </b>
                                  </TableCell>
                                </TableRow>                      
                              </Table>
                              <TablePagination
                                component="div"
                                count={searchQuery ? filteredCashCustomerData.length : cashCustomerData.length}
                                onChangePage={handlePageChange}
                                onChangeRowsPerPage={handleLimitChange}
                                page={page}
                                rowsPerPage={limit}
                                rowsPerPageOptions={[5, 10, 25]}
                              />
                            </TableContainer>
                          ) : null}
                        </Box>                        
                      </CardContent>
                      {cashCustomerData.length > 0 ? (
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={createFile}
                            size="small"
                          >
                            EXCEL
                          </Button>
                          <div>&nbsp;</div>

                          <ReactToPrint
                            documentTitle={'Cash Customer Details Report' + '_' 
                              + selectedSearchValues.monthName 
                              + '-' 
                              + selectedSearchValues.year + '_'
                              + selectedSearchValues.groupName + '_'
                              + selectedSearchValues.factoryName}
                            trigger={() => (
                              <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorCancel}
                                size="small"
                              >
                                PDF
                              </Button>
                            )}
                            pageStyle={getPageMargins()}
                            content={() => componentRef.current}
                          />
                          <div hidden={true}>
                            <CreatePDF
                              ref={componentRef}
                              searchData={selectedSearchValues}
                              searchDate={cashCustomerDetail}
                              cashCustomerData={cashCustomerData}
                              total={totalAmount}
                              selectedDatePDF={selectedDatePDF}
                              month={month[(selectedDate.getMonth() + 1).toString() - 1]}
                            />
                          </div>
                        </Box>
                      ) : null}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
